import React from 'react'
import styled from 'styled-components';
import avatarWebp from '../img/avatar.webp';
import avatarJpg from '../img/avatar.jpg';
import PrimaryButton from './PrimaryButton';

function ImageSection() {
    return (
        <ImageSectionStyled>
            <picture>
                <source srcSet={avatarWebp} type="image/webp" />
                <img src={avatarJpg} width="800" height="800" alt="Amritanshu Suyal" />
            </picture>
            <h3>I am <span>Amritanshu</span></h3>
            <p className="paragraph">
                I build the infrastructure that lets AI agents actually work inside enterprise software. At Darwinbox, an HRMS serving 4M+ enterprise users, I work on the agent platform — the layer between LLMs and real business systems.
                <br /><br />
                Most of the hard problems here aren't prompting. They're cost, correctness, and trust.
            </p>
            <a href="https://drive.google.com/uc?export=download&id=1MJ50aA6VYjfRoU6xcYnS3a_wZZefAohU" target="_blank" rel="noreferrer"><PrimaryButton title={'View Resume'} /></a>
        </ImageSectionStyled>
    )
}

const ImageSectionStyled = styled.div`
    img{
        width: 60%;
        max-width: 260px;
        height: auto;
        border-radius: 50%;
        object-fit: cover;
        margin-bottom: 1.5rem;
    }
    h3{
        font-size: var(--font-size-h3);
        color: var(--white-color);
        span{
            font-size: var(--font-size-h3);
        }
    }
    .paragraph{
        padding: 1rem 0 1.5rem;
    }
`;
export default ImageSection;
